import { ApiTokenStorage } from '@/module/auth';
import { UserCookieManager } from '@/shared/cookies/userCookieManager';
import { type UserInfo } from '@/types';

export const setUserSession = (user: Partial<UserInfo>) => {
  ApiTokenStorage.set(user.token || '');
  UserCookieManager.setSession();
};

export const clearUserSession = () => {
  ApiTokenStorage.remove();
  UserCookieManager.clearAllUserCookies();
};
